import { FALLBACK_KEY } from './fallback';

export const GROUPING_TYPE = {
  CI: 'ci',
  TQL_NODE: 'tql_node',
  FALLBACK: FALLBACK_KEY,
};